import { render, staticRenderFns } from "./UserMenuOptions.vue?vue&type=template&id=612faeea&scoped=true"
import script from "./UserMenuOptions.vue?vue&type=script&lang=js"
export * from "./UserMenuOptions.vue?vue&type=script&lang=js"
import style0 from "./UserMenuOptions.vue?vue&type=style&index=0&id=612faeea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612faeea",
  null
  
)

export default component.exports